import { useCallback } from 'react';
import { percent, px } from "../../../helper/units.js";
export const useCalcCSSPosition = (minValue, maxRange) => useCallback((value, offset) => {
  const position = percent((value - minValue) / maxRange);
  if (offset) {
    return `calc(${position} + ${px(offset)})`;
  }
  return position;
}, [maxRange, minValue]);